import './landingpage.css';

import { Box, Card, Grid, Stack, SxProps, Theme } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { jhTheme } from '../../themeProvider';
import { ReactComponent as IconComputer } from './computer.svg';
import { ReactComponent as IconFile } from './file.svg';
import { ReactComponent as IconCalender } from './kalender.svg';

interface InfoBoxProps {
  IconComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  header: string;
  content: string;
  sx?: SxProps<Theme>;
}

const InfoBox = ({ IconComponent, header, content, sx = [] }: InfoBoxProps) => {
  return (
    <Box
      sx={[
        {
          backgroundColor: '#fff',
          textAlign: 'center',
          color: jhTheme.palette.text.secondary,

          boxShadow: 3,
          minHeight: 265,
          minWidth: 200,
          maxHeight: 300,
          maxWidth: 300,
          borderRadius: 0,
          fontFamily: 'JHFontBold,arial,sans-serif',
          paddingTop: 5,
          margin: 0,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <IconComponent
        fill={jhTheme.palette.primary.main}
        width="72"
        height="72"
      />
      <h1 className="infoboxTitle">{header}</h1>
      <h4 className="infoboxContent">{content}</h4>
    </Box>
  );
};

export const LandingPage = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'rgb(241,241,241)',
      }}
    >
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          backgroundImage: "url('./landingpage_rcm.png')",
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          height: '65vh',
          boxSizing: 'border-box',
          position: 'relative',
        }}
      >
        <Grid
          container
          sx={{
            marginBottom: '20px',
            height: '65vh',
            maxWidth: '1200px',
            alignItems: 'center',
          }}
        >
          <Grid item width="50%">
            <Stack
              direction="row"
              justifyContent="flex-end"
              width="100%"
              maxHeight="65vh"
              bottom="10vh"
            >
              {' '}
              {/* wrapper needed, to get right-alignment within Grid item */}
              <Card className="card" sx={{ borderRadius: '0' }}>
                <CardContent>
                  <p className="cardSubTitle">{t('LandingPageCardSubTitle')}</p>
                  {/* LandingPageCardTitle</Trans></h1> */}
                  <h2 className="cardTitle">
                    <Trans t={t}>LandingPageCardTitle</Trans>
                  </h2>
                  <p className="cardSubText">
                    <Trans t={t}>LandingPageCardSubText</Trans>
                  </p>
                </CardContent>
              </Card>
            </Stack>
          </Grid>
          <Grid item width="50%" />
        </Grid>
      </Stack>
      <Box
        sx={{
          marginTop: '1em',
          marginBottom: '2em',
          display: 'flex',
          alignContent: 'center',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h1 className="infoTextTitle">{t('LandingPageInfoTextTitle')}</h1>

        <Grid
          container
          spacing={3}
          justifyContent="center"
          direction="row"
          alignItems="center"
          display="flex"
          margin={0}
          padding={0}
          maxWidth="1200px"
        >
          <Grid item>
            <InfoBox
              IconComponent={IconFile}
              header={t('LandingPageBox1Header')}
              content={t('LandingPageBox1Content')}
            />
          </Grid>
          <Grid item>
            <InfoBox
              IconComponent={IconCalender}
              header={t('LandingPageBox2Header')}
              content={t('LandingPageBox2Content')}
            />
          </Grid>
          <Grid item>
            <InfoBox
              IconComponent={IconComputer}
              header={t('LandingPageBox3Header')}
              content={t('LandingPageBox3Content')}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

InfoBox.defaultProps = {
  sx: [],
};
